import { z } from "zod/v4";

export const notificationTypeSchema = z.enum([
	"game_reminder_1d",
	"game_reminder_1h",
	"game_reminder_15m",
	"game_starting",
	"game_cancelled",
	"game_updated",
	"game_full",
	"spot_opened",
	"player_joined",
	"player_left",
	"game_result",
	"club_join_request",
	"club_request_approved",
	"club_request_denied",
	"tier_up",
	"tier_down",
	"achievement",
	"broadcast",
]);

export const notificationSchema = z.object({
	id: z.string().uuid(),
	user_id: z.string(),
	type: z.string(),
	title: z.string(),
	body: z.string(),
	data: z.unknown(),
	read: z.boolean(),
	created_at: z.coerce.date(),
});

export const broadcastNotificationSchema = z.object({
	title: z.string().min(1, "Title is required"),
	body: z.string().min(1, "Body is required"),
	user_ids: z.array(z.string()).optional(),
});
